import React, { useState } from "react";
import { toast } from "sonner";
import { ShieldCheck } from "lucide-react";
import api from "../api";
import { usePageTitle } from "../components/common";

const TYPES = [
  { v: "copie", l: "Demander une copie de mes données" },
  { v: "rectification", l: "Demander une rectification" },
  { v: "suppression", l: "Demander une suppression (lorsque juridiquement possible)" },
];

export default function Rgpd() {
  usePageTitle("Mes données personnelles");
  const [form, setForm] = useState({ first_name: "", email: "", request_type: "copie", message: "", website: "" });
  const [sending, setSending] = useState(false);
  const [done, setDone] = useState(false);
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setSending(true);
    try {
      await api.post("/rgpd-request", form);
      setDone(true);
      toast.success("Ta demande a bien été enregistrée ✨");
    } catch {
      toast.error("Une erreur est survenue.");
    } finally { setSending(false); }
  };

  if (done)
    return (
      <div className="container-x py-20 text-center fade-up max-w-lg">
        <ShieldCheck className="mx-auto text-[#C9A56A]" size={30} />
        <h1 className="mt-4 font-serif text-2xl text-[#5A3A4B]">Demande enregistrée</h1>
        <p className="mt-3 text-sm text-[#7A5D58]">Un accusé de réception vient de t'être envoyé. Ta demande sera traitée dans les délais légaux.</p>
      </div>
    );

  return (
    <div className="container-x py-12 sm:py-20 fade-up max-w-lg">
      <h1 className="font-serif text-3xl sm:text-4xl font-medium text-[#5A3A4B]">Mes données personnelles</h1>
      <p className="mt-3 text-sm text-[#7A5D58] leading-relaxed">
        Tu peux exercer tes droits sur tes données (accès, rectification, effacement). Tu peux aussi
        introduire une réclamation auprès de la CNIL.
      </p>
      <div className="gold-divider my-6 w-28" />
      <form onSubmit={submit} className="card-soft p-6 space-y-4" data-testid="rgpd-form">
        <div><label className="field-label">Prénom</label><input required className="field-input" value={form.first_name} onChange={set("first_name")} data-testid="rgpd-first" /></div>
        <div><label className="field-label">Email</label><input required type="email" className="field-input" value={form.email} onChange={set("email")} data-testid="rgpd-email" /></div>
        <div>
          <label className="field-label">Type de demande</label>
          <div className="space-y-2">
            {TYPES.map((t) => (
              <label key={t.v} className="flex items-start gap-2 cursor-pointer text-sm text-[#7A5D58]">
                <input type="radio" name="rtype" className="mt-1 accent-[#5A3A4B]" checked={form.request_type === t.v} onChange={() => setForm({ ...form, request_type: t.v })} data-testid={`rgpd-type-${t.v}`} />
                {t.l}
              </label>
            ))}
          </div>
        </div>
        <div><label className="field-label">Message (facultatif)</label><textarea rows={3} className="field-input resize-none" value={form.message} onChange={set("message")} data-testid="rgpd-message" /></div>
        <input type="text" tabIndex={-1} autoComplete="off" value={form.website} onChange={set("website")} className="hidden" aria-hidden="true" />
        <button type="submit" disabled={sending} className="btn-primary w-full" data-testid="rgpd-submit">
          {sending ? "Envoi…" : "Envoyer ma demande"}
        </button>
      </form>
    </div>
  );
}
